export default __webpack_public_path__ + "static/media/Incursion Shroud.eba1c2fb.jpg";